import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { DialogMessage } from './Widgets/DialogMessage';
import { Audio } from './Widgets/Audio';

class TEST2 extends Component {
    constructor(props) {
        super(props);
        this.state = { showDialog: false, input: '', slotNum: '', scannedStuff: [] };
        this.inputRef = React.createRef();
        this.slotRef = React.createRef();
        this.dialogRef = React.createRef();

        this.playFailure = this.playFailure.bind(this);

        // bind handlers so we can add/remove listeners
        this.handleFocusIn = this.handleFocusIn.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleMouseDown = this.handleMouseDown.bind(this);
    }

    componentDidMount() {
        if (this.inputRef.current) this.inputRef.current.focus();
    }

    componentDidUpdate(prevProps, prevState) {
        // When dialog opens
        if (!prevState.showDialog && this.state.showDialog) {
            // focus after mount/animation
            setTimeout(() => {
                if (this.slotRef.current) this.slotRef.current.focus();
            }, 50);
            this.startFocusTrap();
        }

        // When dialog closes
        if (prevState.showDialog && !this.state.showDialog) {
            this.stopFocusTrap();
            setTimeout(() => {
                if (this.inputRef.current) this.inputRef.current.focus();
            }, 50);
        }
    }

    componentWillUnmount() {
        this.stopFocusTrap();
    }

    // ----- Focus Trap implementation -----
    startFocusTrap() {
        // Install global listeners only once per open
        document.addEventListener('focusin', this.handleFocusIn, true);
        document.addEventListener('keydown', this.handleKeyDown, true);
        document.addEventListener('mousedown', this.handleMouseDown, true);
    }

    stopFocusTrap() {
        document.removeEventListener('focusin', this.handleFocusIn, true);
        document.removeEventListener('keydown', this.handleKeyDown, true);
        document.removeEventListener('mousedown', this.handleMouseDown, true);
    }

    handleFocusIn(e) {
        if (!this.state.showDialog) return;
        const dialog = this.dialogRef.current;
        if (!dialog) return;
        if (!dialog.contains(e.target)) {
            // keep focus inside dialog
            e.stopPropagation();
            if (this.slotRef.current) this.slotRef.current.focus();
        }
    }

    handleKeyDown(e) {
        if (!this.state.showDialog) return;
        const dialog = this.dialogRef.current;
        if (!dialog) return;

        // Trap Tab navigation within the dialog
        if (e.key === 'Tab') {
            const focusables = dialog.querySelectorAll(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            const list = Array.from(focusables).filter(el => !el.hasAttribute('disabled') && el.offsetParent !== null);
            if (list.length === 0) {
                // nothing focusable? keep on the slot input
                if (this.slotRef.current) this.slotRef.current.focus();
                e.preventDefault();
                return;
            }
            const first = list[0];
            const last = list[list.length - 1];
            const active = document.activeElement;

            if (!e.shiftKey && active === last) {
                e.preventDefault();
                first.focus();
            } else if (e.shiftKey && active === first) {
                e.preventDefault();
                last.focus();
            }
        }
    }

    handleMouseDown(e) {
        if (!this.state.showDialog) return;
        const dialog = this.dialogRef.current;
        if (!dialog) return;
        if (!dialog.contains(e.target)) {
            // prevent outside clicks from stealing focus while open
            e.preventDefault();
            if (this.slotRef.current) this.slotRef.current.focus();
        }
    }
    // -------------------------------------

    openSlotDialog = () => {
        this.setState({ showDialog: true, slotNum: '' });
    };

    confirmSlot = () => {
        const slot = this.state.slotNum.trim();
        const pattern = /[Ss]lot-.*/;
        const isValid = slot && pattern.test(slot);
        if (!isValid) {
            this.playFailure();
            this.setState({ slotNum: '' });
            return;
        }
        this.setState((s) => ({
            scannedStuff: [...s.scannedStuff, { tote: s.input, slot }],
            input: '',
            slotNum: '',
            showDialog: false
        }));
    };

    playFailure() {
        const audioElbadISBN = document.getElementsByClassName('audio-element-failure')[0];
        if (audioElbadISBN?.paused) audioElbadISBN.play();
        else if (audioElbadISBN) audioElbadISBN.currentTime = 0;
    }

    render() {
        return (
            <div>
                <Audio />

                <DialogMessage
                    showDialog={this.state.showDialog}
                    dialogTitle="Scan Slot Number"
                    closeDialog={() => this.setState({ showDialog: false })}
                    dialogContent={
                        this.state.showDialog && (
                            <div ref={this.dialogRef}>
                                <label htmlFor="slotNum" className="sr-only">
                                    Slot Number
                                </label>
                                <input
                                    id="slotNum"
                                    name="slotNum"
                                    type="text"
                                    ref={this.slotRef}
                                    value={this.state.slotNum}
                                    required
                                    onChange={(e) => this.setState({ slotNum: e.target.value })}
                                    onKeyDown={(e) => e.key === 'Enter' && this.confirmSlot()}
                                    autoComplete="off"
                                />
                                <div style={{ marginTop: 12 }}>
                                    <button type="button" onClick={this.confirmSlot}>
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        )
                    }
                />

                {/* Main scanner input */}
                <div>
                    <input
                        ref={this.inputRef}
                        id="scanInput"
                        className="scanIdentifierInput"
                        autoComplete="off"
                        type="text"
                        placeholder="Scan or Enter Tote #"
                        value={this.state.input}
                        onChange={(e) => this.setState({ input: e.target.value.toUpperCase() })}
                        onKeyDown={(e) => e.key === 'Enter' && this.openSlotDialog()}
                        // Optional: remove from tab order while dialog open
                        tabIndex={this.state.showDialog ? -1 : 0}
                    />
                    <button type="button" onClick={this.openSlotDialog} tabIndex={this.state.showDialog ? -1 : 0}>
                        Add
                    </button>
                </div>

                <h1>Scanned Stuff</h1>
                {this.state.scannedStuff.map((x, i) => (
                    <div key={`${x.tote}-${x.slot}-${i}`}>
                        <div>Tote: {x.tote}</div>
                        <div>Slot: {x.slot}</div>
                        <br />
                    </div>
                ))}
            </div>
        );
    }
}

export default withRouter(TEST2);
